module.exports = __webpack_public_path__ + "media/Stepdaughter.a4a0f620.mp3";